import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_large_paywall_update~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_large_paywall_update/walking-f/__b'),
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_large_paywall_update~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_large_paywall_update/activity-female-tai-chi-walking-v2/__b'),
			},
		},
	},
]

export default config
